module.exports = __webpack_public_path__ + "img/profile-selected.c22ceb43.svg";